module.exports = __webpack_public_path__ + "img/roll-up.9fe6797c.png";